import { useEffect, useState } from "react";
import { getSystemHealthData } from "../../../api/systemHealthService";

function SystemHealthCenterPage() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            setLoading(true);

            try {
                const result = await getSystemHealthData();
                setData(result);
            } catch (err) {
                console.error("System Health load failed", err);
            } finally {
                setLoading(false);
            }
        };

        load();
    }, []);

    if (loading) return <div style={{ padding: 20 }}>Loading System Health Center...</div>;
    if (!data) return <div style={{ padding: 20 }}>System health data not available.</div>;

    return (
        <div style={{ padding: 20 }}>
            <h2>System Health Center</h2>

            <p style={{ color: "#666" }}>
                Platform infrastructure monitoring for API, database, WebSocket, security services and background processes.
            </p>

            <div style={gridStyle}>
                <Card title="API" value={data.apiStatus} color="#2E7D32" />
                <Card title="Database" value={data.databaseStatus} color="#1565C0" />
                <Card title="WebSocket" value={data.websocketStatus} color="#7B1FA2" />
                <Card title="JWT Service" value={data.jwtService} color="#3949AB" />
                <Card title="Encryption" value={data.encryptionService} color="#00897B" />
                <Card title="AI Engine" value={data.aiEngine} color="#EF6C00" />
                <Card title="Background Services" value={data.backgroundServices} color="#546E7A" />
                <Card title="SSL Certificate" value={data.sslStatus} color="#2E7D32" />
            </div>

            <div style={gridStyle}>
                <Card title="CPU Usage" value={`${data.cpuUsage}%`} color="#1976D2" />
                <Card title="Memory Usage" value={`${data.memoryUsage}%`} color="#6A1B9A" />
                <Card title="Disk Usage" value={`${data.diskUsage}%`} color="#00897B" />
                <Card title="Error Events" value={data.errorRate} color="#C62828" />
                <Card title="System Logs" value={data.systemLogs} color="#546E7A" />
                <Card title="IoT Online" value={`${data.iotOnline}/${data.iotTotal}`} color="#43A047" />
                <Card title="Blockchain Events" value={data.blockchainEvents} color="#5E35B1" />
                <Card title="Uptime" value={data.uptime} color="#2E7D32" />
            </div>
        </div>
    );
}

function Card({ title, value, color }) {
    return (
        <div style={{ ...cardStyle, borderTop: `6px solid ${color}` }}>
            <div style={{ color: "#666", fontSize: 14 }}>{title}</div>
            <div style={{ fontSize: 28, fontWeight: "bold", marginTop: 10 }}>
                {value}
            </div>
        </div>
    );
}

const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 16,
    marginTop: 20,
};

const cardStyle = {
    background: "white",
    borderRadius: 12,
    padding: 18,
    boxShadow: "0 4px 12px rgba(0,0,0,.08)",
};

export default SystemHealthCenterPage;